import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import ClassroomImg from "../../../assets/images/classroom.png";
import Button from "../../../atoms/Button";
import GroupClass from "../../../organisms/teacher/GroupClass";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import { IGrade } from "../../../pages/teacher/types";
import {
  Context,
  chooseTextbookPath,
  textbookPath,
  activeLearningTextbookPath,
} from "../../../teacherStore";
import { IClass } from "../../../state";
import { parseQueryParams } from "../../../libs/Util";

import styles from "./TeachingClassList.module.scss";

export type Props = {
  classes: IClass[];
  selectedClassIds: number[];
};

const links = [{ name: "クラスを選んで指導書を選ぶ", to: "#" }];

const TeachingClassList: React.FC<Props> = ({ classes, selectedClassIds }) => {
  const { state } = useContext(Context);
  const history = useHistory();
  const isActiveLearningParam =
    parseQueryParams()["isActiveLearning"] === "true";

  const listClass = React.useMemo(() => {
    const grades: IGrade[] = [];
    classes.forEach(cls => {
      if (!grades.find(item => item.grade === cls.grade)) {
        grades.push({
          grade: cls.grade,
          classes: [
            {
              id: cls.id,
              name: cls.full_name,
              charged: cls.charged,
              assumed_entrance_year: cls.assumed_entrance_year,
            },
          ],
        });
      } else {
        const index = grades.findIndex(item => item.grade === cls.grade);
        grades[index].classes.push({
          id: cls.id,
          name: cls.full_name,
          charged: cls.charged,
          assumed_entrance_year: cls.assumed_entrance_year,
        });
      }
    });
    return grades;
  }, [classes]);

  const selectedClasses = React.useMemo(
    () => classes.filter(c => selectedClassIds.includes(c.id)),
    [classes, selectedClassIds],
  );

  const replacePath = React.useCallback(
    (ids: number[]) => {
      const activeLearningParam = isActiveLearningParam
        ? "&isActiveLearning=true"
        : "";
      history.replace(
        `${textbookPath}${chooseTextbookPath}?classList=${ids.join(
          ",",
        )}${activeLearningParam}`,
      );
    },
    [history, isActiveLearningParam],
  );

  const selectClass = (id: number) => {
    const ids = classes
      .filter(cls => cls.id === id || selectedClassIds.includes(cls.id))
      .map(cls => cls.id);
    replacePath(ids);
  };

  const removeClass = (id: number) => {
    const ids = selectedClassIds.filter(clsId => clsId !== id);
    replacePath(ids);
  };

  return (
    <>
      <TeacherHeader links={links} />
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.groupCheck}>
            <img src={ClassroomImg} alt="class-room" />
            <p>授業をするクラスを選んでください</p>
          </div>
          <GroupClass
            listClass={listClass}
            listClassesSelected={selectedClassIds}
            onChooseClass={id => {
              if (selectedClassIds.includes(id)) {
                removeClass(id);
              } else {
                selectClass(id);
              }
            }}
          />
        </div>
        <div className={styles.footer}>
          <div className={styles.footer__content}>
            <h3>選択中のクラス</h3>
            <div className={styles.footer__selectedClass}>
              {selectedClasses.map(cls => (
                <div key={cls.id} onClick={() => removeClass(cls.id)}>
                  <span>{cls.full_name}</span>
                </div>
              ))}
            </div>
          </div>
          <Button
            name="授業をするクラスを確定"
            variant="normal"
            onClick={() => {
              const classListParam = `?classList=${selectedClassIds.join(",")}`;
              const path = isActiveLearningParam
                ? `${activeLearningTextbookPath}${classListParam}&code=${state.available_item_codes[0]}`
                : `${textbookPath}${classListParam}`;
              history.push(path);
            }}
            disabled={selectedClassIds.length === 0}
          />
        </div>
      </div>
    </>
  );
};

export default TeachingClassList;
